export default __webpack_public_path__ + "static/media/text.f0b8f64a.svg";